import { render } from "./OpenQuestionResult.vue?vue&type=template&id=01cfbbe6"
import script from "./OpenQuestionResult.vue?vue&type=script&lang=js"
export * from "./OpenQuestionResult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__